import {
  applyTzToInterview,
  getHireInterviewsHiringScheduleListQueryOptions,
  getHireManagerAvailabilityJobsWeekRetrieveQueryOptions,
  getHireManagerAvailabilityWeekListQueryOptions,
  type HiringScheduleItem,
} from "@sidegigllc/api/client";
import { AVAILABILITY_MINE, AVAILABILITY_OFF } from "domains/hire/components/HiringScheduleFilters/constants";
import type { WarmableQuery } from "routing/warmQueries";
import { hiringScheduleWeekRange } from "./weekRange";

type QueriesInput = { calendarDate: Date; availability?: string };

export const zoneInterviews = (interviews: Array<HiringScheduleItem>) =>
  interviews.map((item) => applyTzToInterview(item));

export const hiringScheduleInterviewsQuery = ({ calendarDate }: QueriesInput) => {
  const range = hiringScheduleWeekRange(calendarDate);
  return getHireInterviewsHiringScheduleListQueryOptions({ start_time: range.start, end_time: range.end });
};

export const myAvailabilityQuery = ({ availability = AVAILABILITY_MINE }: QueriesInput) =>
  getHireManagerAvailabilityWeekListQueryOptions({ query: { enabled: availability === AVAILABILITY_MINE } });

export const jobAvailabilityQuery = ({ availability = AVAILABILITY_MINE }: QueriesInput) =>
  getHireManagerAvailabilityJobsWeekRetrieveQueryOptions(availability, {
    query: { enabled: availability !== AVAILABILITY_MINE && availability !== AVAILABILITY_OFF },
  });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  hiringScheduleInterviewsQuery(input),
  myAvailabilityQuery(input),
  jobAvailabilityQuery(input),
];
